import type { IEntityModel } from './base'

export enum IQuestionnaireDisplayRuleTargetType {
  Section = 'section',
  Question = 'question',
  Submit = 'submit',
}

export interface IQuestionnaireDisplayRuleTarget extends IEntityModel {
  displayRuleId: string
  type: IQuestionnaireDisplayRuleTargetType
  questionnaireSectionId?: string // foreign key
  questionnaireQuestionId?: string // foreign key
}

export interface IQuestionnaireDisplayRuleTargetSection
  extends IQuestionnaireDisplayRuleTarget {
  type: IQuestionnaireDisplayRuleTargetType.Section
  questionnaireSectionId: string
}

export interface IQuestionnaireDisplayRuleTargetQuestion
  extends IQuestionnaireDisplayRuleTarget {
  type: IQuestionnaireDisplayRuleTargetType.Question
  questionnaireQuestionId: string
}

export interface IQuestionnaireDisplayRuleTargetSubmit
  extends IQuestionnaireDisplayRuleTarget {
  type: IQuestionnaireDisplayRuleTargetType.Submit
}
